function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "airport_1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H24V24H0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm7.3,5.6c0,.1,0,.1-.1.1l-.2.7h-.1A2.9,2.9,0,0,1,18,8l-2.9,2.9,1.8,7.7a1.2,1.2,0,0,1-.2,1l-.9.8-3.5-6.6L8.8,17.3,9,19.1a.5.5,0,0,1-.2.6l-.7.7-1.3-3L3.7,16l.7-.7a.7.7,0,0,1,.6-.2l1.9.3,3.5-3.5L3.7,8.4l.9-.9a.8.8,0,0,1,.9-.3L13.2,9l2.9-2.9a3.8,3.8,0,0,1,1.5-.9h.2l.6-.2a.1.1,0,0,0,.1-.1h.1a.7.7,0,0,1,.7.7Z",
    style: {
      fill: "#353535"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirport);
export default __webpack_public_path__ + "static/media/airport.354504263342d6485bb075e04b1c5d4d.svg";
export { ForwardRef as ReactComponent };